module.exports = __webpack_public_path__ + "img/21-Hair.c09eb83c.png";